import FeaturePageContent from './featurePageContent'

export default FeaturePageContent
